function withinRange(val, min, max) {
  return (typeof min !== "number" || val >= min )
    && (typeof max !== "number" || val < max )
}

export {
  withinRange
}
